<template>
    <div class="pt-15 animated fadeIn equipmentList bgV2">
        <div class="boxShadow setBorderRadius heig-frame-equipment-group">
            <b-row no-gutters>
                <b-col md="12" class="heig-frame-child">
                    <gofix-card class="mb-0 heig-frame-child" fullContent>
                        <gofix-table
                            :settings="tableConfig"
                            :table-items="tableItems"
                            @load-items="getTableData"
                            @new-item="openModal"
                            @row-click="openModal"
                            @delete-items="deleteItems"
                            ref="gofixTable">
                            <template slot="gofix_table:to_recipient" slot-scope="data">
                                {{ data.item.to_recipient ? data.item.to_recipient.replaceAll(",", ", ") : '' }}
                            </template>
                            <template slot="gofix_table:cc_recipient" slot-scope="data">
                                {{ data.item.cc_recipient ? data.item.cc_recipient.replaceAll(",", ", ") : '' }}
                            </template>
                        </gofix-table>
                    </gofix-card>

                    <b-modal :no-close-on-backdrop="true"
                        id="modal-Create"
                        :title="modals.item.title" hide-footer :centered="true"
                        v-model="modals.item.open">
                        <b-form class="pb-20">
                            <b-row>
                                <b-col md="12">
                                    <gofix-form-dropdown
                                        label="Report"
                                        vLabel="reference_value_text"
                                        :filterable="false"
                                        :append-to-body="true"
                                        :required="true"
                                        :show-icon-required="true"
                                        :disabled="modals.item.data.id != null"
                                        :options="modals.item.options.reports"
                                        v-model="modals.item.data.report">
                                    </gofix-form-dropdown>
                                </b-col>
                                <b-col md="12">
                                    <!-- <gofix-form-dropdown
										label="TO Recipient Email"
                                        class="gofixDropdownHideArrow"
										v-model="modals.item.data.to_recipient"
										:options="[]"
										:filterable="false"
                                        required
                                        show-icon-required
										taggable
										pushTags
										multiple
										noDrop>
									</gofix-form-dropdown> -->
                                    <gofix-form-input label="TO Recipient Email" required show-icon-required v-model="modals.item.data.to_recipient" autocomplete="off"></gofix-form-input>
                                </b-col>
                                <b-col md="12">
                                    <!-- <gofix-form-dropdown
										label="CC Recipient Email"
                                        class="gofixDropdownHideArrow"
										v-model="modals.item.data.cc_recipient"
										:options="[]"
										:filterable="false"
                                        required
                                        show-icon-required
										taggable
										pushTags
										multiple
										noDrop>
									</gofix-form-dropdown> -->
                                    <gofix-form-input label="CC Recipient Email" v-model="modals.item.data.cc_recipient" autocomplete="off"></gofix-form-input>
                                </b-col>
                                <b-col md="12">
                                    <gofix-form-input-textarea 
                                        label="Description" 
                                        :rows="5"
                                        v-model="modals.item.data.description">
                                    </gofix-form-input-textarea>
                                </b-col>
                            </b-row>
                        </b-form>
                    <b-button-group class="d-block text-right">
                        <gofix-button label="SAVE" @click="save" :disabled="modals.item.loading" noBorder></gofix-button>
                    </b-button-group>
                </b-modal>
                </b-col>
            </b-row>
        </div>
    </div>
</template>
<script>
    import { filters } from '@/_filterVar.js'
    export default {
        name: 'nlt-address-book',
        data () {
            let filter = JSON.parse(JSON.stringify(filters['nlt_mailing_list']));
            return {
                tableConfig:{
                    name: 'case-address-book',
                    controls:{
                        tableImport: false,
                        tableExport: false,
                        tableColumnSettings: false
                    },
                    filter: filter,
                    page: 1,
                    limit: 100,
                    total: 0,
                    useDatabaseView: false,
                    sortColumn: "id",
                    sortDirection: "asc",
                    fields: [
                        {
                                key: 'actions',
                                label: '',
                                thClass: 'checkbox-column text-center',
                                tdClass: 'checkbox-column text-center',
                                width: 50,
                                thStyle: "width:100px",
                            },
                            {
                                key: 'name',
                                label: 'Report Name',
                                isActive: 1,
                                isFilter: true,
                                with:100,
                                thStyle: "width:250px",
                                sorting: true,
                            },
                            {
                                key: 'description',
                                label: 'Report Description',
                                isActive: 1,
                                isFilter: true,
                                with:350,
                                thStyle: "width:350px",
                                sorting: true,
                            },
                            {
                                key: 'to_recipient',
                                label: 'TO Recipient Email',
                                isActive: 1,
                                isFilter: true,
                                with:300,
                                thStyle: "width:400px",
                                sorting: true,
                            },
                            {
                                key: 'cc_recipient',
                                label: 'CC Recipient Email',
                                thClass: 'th-auto',
                                isActive: 1,
                                isFilter: true,
                                sorting: true,
                            }
                    ]
                },
                tableItems: [],
                modals:{
                    item:{
                        open: false,
                        loading: false,
                        title:"Add Mailing List",
                        data:{
                            id: null,
                            to_recipient: null,
                            cc_recipient: null,
                            description: null,
                            report: null
                        },
                        options: {
                            reports: []
                        }
                    }
                },
                timer: {
                    save: null
                }
            }
        },
        created() {
            this.getReference()
        },
        methods:{
            /*-- Gofix Table --------*/
            async getTableData(callback) {
                const { tableRequest , resolve,reject } = await callback();
                await this.$store.dispatch("NLTMailingListController/getItems", tableRequest)
                .then(response => {
                    this.tableItems = response.items;
                    this.tableConfig.total = response.total;
                    resolve(response);
                })
                .catch(err => {
                    console.log(err);
                    this.$alertNotification("Can not load the items", "danger");
                    reject();
                })
            },
            async deleteItems(callback){
                const { ids,filter, resolve,reject } = await callback();
                this.$store.dispatch("NLTMailingListController/deleteItems", ids)
                    .then(response => {
                        resolve(this.$notificationV2('deleting', 'nlt_address_book'));
                    })
                    .catch(err =>{
                        reject(err);
                    });
            },

            /*-- Validation Data --------*/
            emailValidationCheckFormat(email_address){
                if(!email_address) return true;
                let emails = email_address.split(",")
                if(!emails.length) return true;

                let filters = emails.filter(item => {
                    if(item && item != ''){
                        // let pattern = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,4})+$/;
                        let pattern = /^\w+([\.-]?\w+)*(\+\w+([\.-]?\w+)*)?@\w+([\.-]?\w+)*(\.\w{2,4})+$/;
                        let result = pattern.test(item.trim());
                        return !result;
                    }
                })

                if(filters.length) return true;
                return false;
            },

            /*-- Store Data --------*/
            openModal(item){
                this.modals.item.open = true;
                if(item){
                    this.modals.item.title = "Edit Mailing List";
                    this.modals.item.data = Object.assign(this.modals.item.data, {
                        id: item.id,
                        description: item.description,
                        to_recipient: item.to_recipient,
                        cc_recipient: item.cc_recipient,
                        report: {
                            reference_value_text: item.name,
                            reference_value_abbr: item.key
                        }
                    });

                    // if(item.to_recipient) this.modals.item.data.to_recipient = item.to_recipient.split(",")
                    // if(item.cc_recipient) this.modals.item.data.cc_recipient = item.cc_recipient.split(",")
                }else{
                    this.modals.item.title = "Add Mailing List";
                    this.modals.item.data = {
                        id: null,
                        to_recipient: null,
                        cc_recipient: null,
                        description: null,
                        report: null
                    };
                }
            },
            save() {
                if (this.timer.save) {
                    clearTimeout(this.timer.save);
                    this.timer.save = null;
                }
                this.timer.save = setTimeout(() => {
                    if(!this.modals.item.data.report) return this.$alertNotification("Report name is required.", "danger");
                    if(!this.modals.item.data.to_recipient) return this.$alertNotification("To Recipient email is required.", "danger");
                    
                    let isCheckToRecipient = this.emailValidationCheckFormat(this.modals.item.data.to_recipient);
                    if(isCheckToRecipient) return this.$alertNotification('To Recipient email is not in a correct email format', 'danger');

                    if(this.modals.item.data.cc_recipient) {
                        let isCheckCCRecipient = this.emailValidationCheckFormat(this.modals.item.data.cc_recipient)
					    if(isCheckCCRecipient) return this.$alertNotification('CC Recipient email is not in a correct email format', 'danger');
                    }

                    if(this.modals.item.loading) return;
                    this.modals.item.loading = true;
                    let request = {
                        id: this.modals.item.data.id,
                        name: this.modals.item.data.report.reference_value_text,
                        key: this.modals.item.data.report.reference_value_abbr,
                        to_recipient: this.modals.item.data.to_recipient.replaceAll(", ", ","),
                        cc_recipient: this.modals.item.data.cc_recipient ? this.modals.item.data.cc_recipient.replaceAll(", ", ",") : null,
                        description: this.modals.item.data.description,
                    };

                    let action = 'createItem';
                    let keyMsg = 'adding'
                    if(request.id){
                        action = 'updateItem';
                        keyMsg = 'editing'
                    }
                    this.$store.dispatch(`NLTMailingListController/${action}`, request)
                        .then(result => {
                            this.modals.item.loading = false;
                            this.modals.item.open = false;
                            this.$alertNotification(this.$notificationV2(keyMsg, 'nlt_mailing_list'));
                            this.$refs.gofixTable.reloadTableKeepFilter();
                        })
                        .catch(error => {
                            this.modals.item.loading = false;
                            if(error.response) this.$alertNotification(error.response.data.error.message, "danger");
                        })
                }, 300);
            },

            /*-- Get Data --------*/
            getReference(){
                this.$store.dispatch("ReferenceController/getItems", {
                    limit:-1,
                    page:1,
                    filter: {
                        reference_type:"NLT Mailing List Management",
                    },
                }).then(response => {
                    this.modals.item.options.reports = response.items;
                });
            },
        }
    }
</script>